import { render, staticRenderFns } from "./StepsResume.vue?vue&type=template&id=20b97cd6&scoped=true"
import script from "./StepsResume.vue?vue&type=script&lang=js"
export * from "./StepsResume.vue?vue&type=script&lang=js"
import style0 from "./StepsResume.vue?vue&type=style&index=0&id=20b97cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b97cd6",
  null
  
)

export default component.exports